import { createHttpClient } from "./http";

export class ClienteRepository {
	constructor() {
		this.axios = createHttpClient({ timeout: 300000 });
	}

	async save(data) {
		try {
			const result = await this.axios.post("cliente-unidade-distribuidora", data, {
				headers: {
					Authorization: `Bearer ${localStorage.getItem("access_token")}`,
					"Content-Type": "application/json",
				},
			});

			return result.data;
		} catch (error) {
			if (error.response?.status === 401)
				throw new Error("Usuário não autenticado.");

			throw new Error(error.response?.data?.message || "Erro ao salvar cliente.");
		}
	}

	async update(data) {
		try {
			const result = await this.axios.put("cliente-unidade-distribuidora", data, {
				headers: {
					Authorization: `Bearer ${localStorage.getItem("access_token")}`,
					"Content-Type": "application/json",
				},
			});

			return result.data;
		} catch (error) {
			if (error.response?.status === 401)
				throw new Error("Usuário não autenticado.");

			throw new Error(error.response?.data?.message || "Erro ao atualizar cliente.");
		}
	}

	async getAll(unidadeDistribuidoraId, page = 1, limit = 10, search = "") {
		try {
			const params = { unidadeDistribuidoraId, page, limit };
			if (search) {
				params.search = search;
			}

			const result = await this.axios.get("cliente-unidade-distribuidora", {
				headers: {
					Authorization: `Bearer ${localStorage.getItem("access_token")}`
				},
				params
			});

			return result.data;
		} catch (error) {
			if(error.response?.status === 401)
				throw new Error("Usuário não autenticado.");

			throw new Error(error.message || "Erro ao carregar clientes.");
		}
	}

	async getById(id) {
		try {
			const result = await this.axios.get(`cliente-unidade-distribuidora/${id}`, {
				headers: {
					Authorization: `Bearer ${localStorage.getItem("access_token")}`
				}
			});

			return result.data;
		} catch (error) {
			if(error.response?.status === 401)
				throw new Error("Usuário não autenticado.");
			if(error.response?.status === 404)
				throw new Error("Cliente não encontrado.");

			throw new Error(error.message || "Erro ao carregar cliente.");
		}
	}

	async changeVisibility(id) {
		try {
			const result = await this.axios.put(`cliente-unidade-distribuidora/${id}/change-visibility`, null, {
				headers: {
					Authorization: `Bearer ${localStorage.getItem("access_token")}`,
				},
			});

			return result.data;
		} catch (error) {
			if (error.response?.status === 401)
				throw new Error("Usuário não autenticado.");

			throw new Error("Erro ao alterar visibilidade do cliente.");
		}
	}
}
